import Image from "next/legacy/image";
import Link from "next/link";
import { fitIn } from "@/utils/imageHandler";

function SpotlightCardItem(props) {
  return (
    <Link legacyBehavior href={`/spotlights/${props.slug}`} passHref>
      <a className='relative group'>
        <div className='p-2px rounded-[15px] right-0 bottom-0 absolute w-[94%] h-[94%] opacity-0 duration-300 ease-out lg:group-hover:opacity-100 lg:group-hover:translate-x-2 lg:group-hover:translate-y-2 bg-gradient-to-r from-yellow-1 to-red-1 mb-4'>
          <div className='rounded-[14px] w-full h-full bg-dark-2'></div>
        </div>
        <div
          className={`aspect-[3/4] relative z-10 overflow-hidden rounded-[15px] max-h-[300px] lg:max-h-[380px] transition-transform duration-300 lg:hover:scale-95 lg:group-hover:-translate-x-0 lg:group-hover:-translate-y-2`}
        >
          <Image
            src={fitIn(props.thumbnail_url, 600)}
            alt={props.thumbnail_alt}
            width={300}
            height={400}
            objectFit='cover'
          />
          <div className='absolute inset-0 z-10 rounded-[15px] bg-gradient-to-b from-transparent via-transparent to-dark-1 w-full h-full'></div>
          <div className='absolute h-[70%] w-full bottom-0 left-0 flex flex-col items-start justify-end p-4 lg:p-7 bg-gradient-to-t from-dark-1 to-transparent z-20 rounded-[15px]'>
            <span className='mb-1.5 text-xs font-bold text-transparent md:mb-2 bg-clip-text bg-gradient-to-tr from-yellow-1 to-red-1'>
              {props.content_type.name}
            </span>
            <span className='text-sm font-bold leading-tight text-white capitalize 2xl:leading-snug 2xl:text-lg'>
              {props.title}
            </span>
          </div>
        </div>
      </a>
    </Link>
  );
}

export default SpotlightCardItem;
